import { track } from 'utils/tracking';

/**
 * Helper class to track loading times easily.
 */
export default class TimeTracker {

	/**
	 * Create a new Time tracker.
	 *
	 * @param {string=} labelPrefix - optional prefix for the label of the event
	 * @param {string=} labelSuffix - optional suffix for the label of the event
	 */
	constructor(labelPrefix, labelSuffix) {
		this.labelPrefix = labelPrefix || '';
		this.labelSuffix = labelSuffix || '';
		this.events = {};
	}

	start(label) {
		this.events[label] = Date.now();
	}

	end(label) {
		this.endAt(label, Date.now());
	}

	endAt(label, date) {
		if (typeof this.events[label] !== 'number') return;
		const time = date - this.events[label];
		this.clear(label);
		if (time < 0) return;
		track({
			a: this.labelPrefix + label + this.labelSuffix,
			l: time
		});
	}

	endAll() {
		this.endAllAt(Date.now());
	}

	endAllAt(date) {
		this.events.forEach((label) => this.endAt(label, date));
		this.clearAll();
	}

	clear(label) {
		this.events[label] = undefined;
	}

	clearAll() {
		this.events = {};
	}

}
